var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"coll-fold",class:_vm.collapse ? 'el-icon-s-unfold' : 'el-icon-s-fold',style:(_vm.classObject),on:{"click":_vm.toggleCollapse}})
}
var staticRenderFns = []

export { render, staticRenderFns }